"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceVimeoThumbnailSize = exports.getVimeoThumbnail = void 0;
const constants_1 = require("./constants");
async function getVimeoThumbnail(id) {
    const data = await fetch(`https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${encodeURI(id)}`);
    const awaitedJson = await data.json();
    if (!awaitedJson.thumbnail_url) {
        throw new Error('No thumbnail found');
    }
    return replaceVimeoThumbnailSize(awaitedJson.thumbnail_url);
}
exports.getVimeoThumbnail = getVimeoThumbnail;
function replaceVimeoThumbnailSize(url) {
    return url.replace(/_\d+x\d+/, `_${constants_1.DEFAULT_THUMBNAIL_SIZE}`);
}
exports.replaceVimeoThumbnailSize = replaceVimeoThumbnailSize;
//# sourceMappingURL=get-vimeo-thumbnail.js.map